// display metadata
$('body').on('click', '.displayMeta', function (e) {
  e.preventDefault();
  var opts = $(this).data('metaOpts');
  ht.displayMeta(opts);
});
